module.exports = __webpack_public_path__ + "static/media/octagon.0b1d3eb8.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@wikipathways/pvjs/lib/icons/octagon.svg
// module id = 678
// module chunks = 0